// extracted by mini-css-extract-plugin
module.exports = {"confirmAlert":"ProductSidebar_confirmAlert__IcwuO","confirmAlertIcon":"ProductSidebar_confirmAlertIcon__1P11Q","confirmAlertMessage":"ProductSidebar_confirmAlertMessage__pzpgX"};